import { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "../i18n";

const LanguageContext = createContext(null);

export const useLang = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("veyrone-lang");
    return LANGS.some((l) => l.code === saved) ? saved : "EN";
  });

  useEffect(() => {
    localStorage.setItem("veyrone-lang", lang);
    const rtl = lang === "AR";
    document.documentElement.lang = rtl ? "ar" : lang.toLowerCase();
    document.documentElement.dir = rtl ? "rtl" : "ltr";
  }, [lang]);

  const t = (path) => {
    const lookup = (src) => path.split(".").reduce((o, k) => (o || {})[k], src);
    const val = lookup(translations[lang]);
    if (val !== undefined) return val;
    const fallback = lookup(translations.EN);
    return fallback !== undefined ? fallback : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageProvider;
